// material-ui

// ==============================|| MAIN LAYOUT - FOOTER ||============================== //

export default function Footer() {
  return <></>;
}
